import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Paper, Typography, useTheme } from '@mui/material';

import { ReactComponent as ArrowRight } from 'assets/images/arrow_right_1.svg';
import { CloseButton, Dialog, DialogContent, DialogTitle } from 'components';
import { ROUTES } from 'consts';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

interface PaymentCompleteDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
}

export const PaymentCompleteDialog = ({ visible = false, setVisible = () => {} }: PaymentCompleteDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Dialog
      onClose={() => setVisible(false)}
      open={visible}
      PaperProps={{ sx: { marginBottom: 12, overflow: 'unset' } }}
      fullScreen={false}
    >
      <DialogTitle>
        <Typography variant="h5" component="span">
          Payment Received
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box paddingTop={2}>
          <Paper
            onClick={() => {
              setVisible(false);
              navigate(`/${orgSlug}/${ROUTES.DASHBOARD}`);
            }}
            sx={{ padding: 3, cursor: 'pointer' }}
          >
            <Grid container>
              <Grid item xs={9}>
                <Typography color="primary" variant="body2" fontWeight="bold">
                  Dashboard
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  sx={{
                    marginTop: 1,
                  }}
                >
                  Go see the Zones in action with real-time cleaning data and metrics.
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ArrowRight
                  style={{
                    width: 32,
                    color: theme.palette.primary.main,
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Box>
        <Box paddingTop={2} marginBottom={6}>
          <Paper
            onClick={() => {
              setVisible(false);
              navigate(`/${orgSlug}/${ROUTES.ZONES}/${ROUTES.ZONES_ACTIVE}`);
            }}
            sx={{
              padding: 3,
              cursor: 'pointer',
            }}
          >
            <Grid container>
              <Grid item xs={9}>
                <Typography color="primary" variant="body2" fontWeight="bold">
                  Zones
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  sx={{
                    marginTop: 1,
                  }}
                >
                  Need to make some adjustments? No worries, head over to the Zones page and easily make edits.
                </Typography>
              </Grid>
              <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ArrowRight
                  style={{
                    width: 32,
                    color: theme.palette.primary.main,
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </DialogContent>

      <CloseButton onClick={() => setVisible(false)} />
    </Dialog>
  );
};
